<!--
Copyright (c) 2024 Antmicro <www.antmicro.com>

SPDX-License-Identifier: Apache-2.0
-->

<!-- eslint-disable max-len -->
<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.9982 2H14.2335H10.4688M17.9982 2V5.29412V9.52941M17.9982 2L14.2335 5.76471L12.3511 7.64706L11.4099 8.58824" stroke="white" stroke-width="2"/>
        <path d="M2.00184 18L5.76654 18L9.53125 18M2.00184 18L2.00184 14.7059L2.00184 10.4706M2.00184 18L5.76654 14.2353L7.6489 12.3529L8.59007 11.4118" stroke="white" stroke-width="2"/>
    </svg>
</template>
